/**
 * Recarrega as opções de "Coluna no Kanban da carteira" quando o dono da conta muda.
 */
(function ($) {
    function fasesUrl() {
        const cfg = window.CarteiraClienteFormConfig || {};
        if (cfg.fasesUrl) {
            return cfg.fasesUrl;
        }
        if (typeof window.siteUrl === "function") {
            return window.siteUrl("/painel/carteira/opcoes/fases");
        }
        return "/painel/carteira/opcoes/fases";
    }

    function rebuildFaseSelect($fase, fases, selectedId) {
        const wanted = selectedId != null ? String(selectedId) : String($fase.val() || "");
        $fase.empty();
        $fase.append($("<option>", { value: "", text: "Sem fase" }));
        (fases || []).forEach((row) => {
            if (row == null || row.id == null) {
                return;
            }
            $fase.append(
                $("<option>", {
                    value: String(row.id),
                    text: row.nome || String(row.id),
                }),
            );
        });
        const ok = wanted && (fases || []).some((r) => String(r.id) === wanted);
        $fase.val(ok ? wanted : "");
    }

    function loadFasesForDono($fase, donoId, preserveSelection) {
        const params = {};
        if (donoId !== "" && donoId != null) {
            params.dono_id = donoId;
        }
        return $.getJSON(fasesUrl(), params)
            .done((data) => {
                rebuildFaseSelect(
                    $fase,
                    Array.isArray(data) ? data : [],
                    preserveSelection ? $fase.val() : null,
                );
            })
            .fail(() => {
                rebuildFaseSelect($fase, [], null);
            });
    }

    function bindCarteiraClienteForm(context) {
        const $dono = $('select[name="dono_id"]', context);
        const $fase = $('select[name="carteira_cliente_fase_id"]', context);
        if (!$dono.length || !$fase.length) {
            return;
        }

        const cfg = window.CarteiraClienteFormConfig || {};
        $dono.off("change.carteiraClienteFases");
        $dono.on("change.carteiraClienteFases", function () {
            if (cfg.colunasCompartilhadas) {
                return;
            }
            const donoId = $(this).val();
            loadFasesForDono($fase, donoId, false);
        });
    }

    Eloca.behaviors.carteiraClienteForm = function (context) {
        bindCarteiraClienteForm(context);
    };
})(jQuery);
